import {Component, computed, input} from '@angular/core';
import {PhaseStatusView, TenderPhaseType} from '@frontend/shared-api';
import {TenderPhaseActionButtonsComponent} from '../tender-phase-action-buttons/tender-phase-action-buttons.component';
import {PhaseBarComponent} from '../../../../../shared/components/provider/phase-bar/phase-bar.component';
import {getProviderPhaseColor} from '../../../../../shared/constants/provider-phase.constants';

@Component({
  selector: 'app-tender-phase',
  imports: [TenderPhaseActionButtonsComponent, PhaseBarComponent],
  templateUrl: './tender-phase.component.html',
  styleUrl: './tender-phase.component.scss',
})
export class TenderPhaseComponent {
  readonly tenderId = input.required<number>();
  readonly phaseStatusInfo = input.required<PhaseStatusView>();

  protected readonly providerPhaseColor = computed(() =>
    getProviderPhaseColor(this.phaseStatusInfo().status),
  );
  protected readonly TenderPhaseType = TenderPhaseType;
}
